"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  desktop: {
    task: {
      inMorning: '凌晨',
      morning: '上午',
      noon: '中午',
      afternoon: '下午',
      evening: '晚上',
      good: '好',
      year: '年',
      month: '月',
      day: '号',
      todayAll: '待办任务'
    },
    person: {
      personal: '个人中心',
      position: '职位',
      number: '访问次数',
      login: '最近登录',
      office: '所属组织',
      Authorized: '授权审批',
      attionShip: '关注船舶',
      collect: '我的收藏'
    },
    vessel: {
      total: '单船业务总览(建设中)',
      singleShip: '单船画像'
    },
    msg: {
      remind: '待阅提醒'
    },
    chart: {
      vesselChart: '船舶统计分析(建设中)',
      shipPerformance: '管船表现',
      checkBoard: '登轮检查统计',
      budgetReport: '年度预算与实际执行报表',
      unitNum: '单位: 次',
      unitTenThousandYuan: '单位: 万元',
      budget: '预算',
      actual: '实际',
      January: '1月',
      February: '2月',
      March: '3月',
      April: '4月',
      May: '5月',
      June: '6月',
      July: '7月',
      August: '8月',
      September: '9月',
      October: '10月',
      November: '11月',
      December: '12月',
      security: '安全',
      shipNum: '来源:',
      ships: '艘船舶业务；'
    },
    msgRead: {
      read: '消息待阅'
    },
    file: {
      fileRead: '文件查阅'
    },
    monitor: {
      monitor: '监控提醒'
    },
    report: {
      reportView: '报告查阅'
    }
  }
};